import { isAbasteceBiz, isFoodBiz } from '@/common/utils/BizUtils'
import { SHOP_FILTER_OPTIONS } from '@/consts'

export default {
  isFoodBiz(state) {
    return isFoodBiz(state.login.userInfo.bizId)
  },
  isAbasteceBiz(state) {
    return isAbasteceBiz(state.login.userInfo.bizId)
  },
  needInitI18n (state) {
    let { locale, country } = state.login.userInfo
    return (!locale || !country) && state.login.uname
  },
  areaGroup (state) {
    let { region, city, district, area } = state.areaGroup
    return {
      regionId: region.id,
      cityId: city.id,
      districtId: district.id,
      areaId: area.id ? area.id : ''
    }
  },
  geo (state) {
    return {
      lng: state.geo.lng,
      lat: state.geo.lat
    }
  },
  statusOptions (state) {
    let countMap = state.countByStatus
    let resultArr = []
    SHOP_FILTER_OPTIONS.forEach((i) => {
      // 去掉【全部】选项
      if (i.value !== 'status:-1') {
        resultArr.push({
          value: i.value,
          label: i.label,
          count: countMap[i.value] || 0
        })
      }
    })
    return resultArr
  }
}
